//#region src/locales/zh-Hant/stage.yaml
var data = {
	"chat": {
		"actions": { "retry": "重試" },
		"message": { "character-name": {
			"core-system": "核心系統",
			"you": "你"
		} },
		"reasoning": "推理",
		"sessions": {
			"title": "對話",
			"new": "+ 新增",
			"empty": "尚無對話",
			"cloud-badge": "已同步至雲端",
			"new-chat-fallback": "新對話",
			"delete": "刪除對話"
		}
	},
	"render-error": {
		"title": "{renderer} 無法算繪這個模型",
		"description": "模型已經選取，但舞台無法顯示它。",
		"report-description": "{renderer} 無法算繪選取的模型。\n模型 ID：{modelId}\n錯誤：{error}"
	},
	"message": "說點什麼...",
	"send-mode": {
		"title": "傳送按鍵",
		"double-enter": "Enter + Enter"
	},
	"speech-output": {
		"mute": "靜音語音",
		"unmute": "恢復語音"
	},
	"operations": {
		"load-models": "載入模型",
		"load-models-status": {
			"loading": "模型載入中",
			"ready": "已就緒"
		}
	},
	"select-a-audio-input": "選擇一個音訊輸入裝置",
	"select-a-model": "選擇一個模型",
	"select-a-voice": "選擇一個聲線",
	"viewers": { "debug-menu": {
		"emotions": "表情",
		"emotions-btn": {
			"angry": "😠 生氣",
			"awkward": "😳 尷尬",
			"happy": "😄 開心",
			"neutral": "🙂 日常",
			"question": "🤔 疑問",
			"sad": "😫 難過",
			"surprised": "🤯 驚喜",
			"think": "🤨 思考"
		},
		"vrm": {
			"camera": "攝影機",
			"model": { "title": "模型" }
		}
	} },
	"profile-switcher": {
		"no-profile": "無設定檔",
		"no-profiles": "暫時沒有設定檔",
		"save-as-new": "儲存為新設定檔",
		"new-profile-name": "設定檔名稱",
		"manage": "管理設定檔"
	},
	"promo-banner": { "items": {
		"signin": {
			"watermark": "月石",
			"fallbackLabel": "月石禮包",
			"title": "7日簽到",
			"eventName": "登入即可領取星塵、頭像框與啟動禮物。",
			"reward": "最多 120 星塵",
			"cta": "登入"
		},
		"build": {
			"watermark": "建造",
			"fallbackLabel": "建造獎勵",
			"title": "補給箱獎勵",
			"eventName": "完成建造任務即可獲得獎勵券與雙倍材料。",
			"reward": "5 張補給券 + 升級材料",
			"cta": "查看任務"
		},
		"spring": {
			"watermark": "春天",
			"fallbackLabel": "春日抽獎",
			"title": "扭蛋嘉年華",
			"eventName": "參加春日抽獎，解鎖氣泡、掛飾與主題家具。",
			"reward": "首抽半價 + 稀有掛飾",
			"cta": "立即抽取"
		},
		"coupon": {
			"watermark": "對話",
			"fallbackLabel": "優惠券",
			"title": "儲值優惠券",
			"eventName": "完成聊天互動即可領取擴充包與語音包優惠券。",
			"reward": "滿 30 減 6 / 滿 68 減 15",
			"cta": "領取優惠券"
		},
		"home": {
			"watermark": "首頁",
			"fallbackLabel": "房間主題",
			"title": "春日主題更新",
			"eventName": "解鎖窗戶、書桌與夜燈主題，為房間煥然一新。",
			"reward": "登入即贈主題抽獎券",
			"cta": "查看主題"
		}
	} },
	"waiting": "等待中",
	"websocket-status": {
		"connected": "已連線",
		"disconnected": "未連線",
		"open-settings": "開啟連線設定"
	}
};
//#endregion
export { data as default };
